import { useEffect } from 'react';

let lastHeight = 0;

/**
 * Height of the content itself. body.scrollHeight can't be used: the wrapper
 * and layout have min-height: 100vh, and in an iframe 100vh is whatever height
 * the parent last gave us, so every +5 made the page grow again, forever.
 */
function measureContent() {
    const wrapper = document.querySelector('.eva_wrapper_qp');
    if (!wrapper) return 0;
    const bottom = Math.max(
        0,
        ...Array.from(wrapper.children).map((el) => el.getBoundingClientRect().bottom)
    );
    return Math.ceil(bottom + window.scrollY);
}

/** Tells the embedding page how tall we are so it can resize its iframe. */
export function postHeight() {
    if (window.parent === window) return;
    const height = measureContent() + 30;
    if (height <= 5 || height === lastHeight) return;
    lastHeight = height;
    window.parent.postMessage(`cco_height_${height}`, '*');
}

/**
 * The original calls PostHeight() after every layout change (pricing results,
 * field show/hide). Watching the content covers all of those at once.
 */
export function usePostHeight(enabled = true) {
    useEffect(() => {
        if (!enabled || window.parent === window) return undefined;

        lastHeight = 0;
        postHeight();
        if (typeof ResizeObserver === 'undefined') return undefined;

        const observer = new ResizeObserver(postHeight);
        const wrapper = document.querySelector('.eva_wrapper_qp');
        if (wrapper) Array.from(wrapper.children).forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, [enabled]);
}